export const STORYBLOK_GLOBAL_STORIES = {
    GLOBAL_CONFIG_MAIN: 'global-config/main',
} as const;

export const STORYBLOK_TEMPLATE_STORIES = {
    SLP: 'templates/slp',
    SDP: 'templates/sdp',
} as const;

export const STORYBLOK_LEGAL_PAGES_ROUTES = {
    FAQ: '/faq',
    PRIVACY_POLICY: '/privacy-policy',
    TERMS_AND_CONDITIONS: '/terms-and-conditions',
    LOGISTICS_TERMS_AND_CONDITIONS: '/logistics-terms-and-conditions',
    POWERTRAIN_WARRANTY_TERMS_AND_CONDITIONS: '/powertrain-warranty-terms-and-conditions',
    FLEEQUID_CARE_TERMS_AND_CONDITIONS: '/fleequid-care-terms-and-conditions',
    DEPOT_TERMS_AND_CONDITIONS: '/depot-terms-and-conditions',
    PRICING_BUYER: '/pricing-buyer',
    PRICING_SELLER: '/pricing-seller',
};

export const STORYBLOK_ROUTES = {
    HOMEPAGE: '/',
    TRUST_REPORT: '/how-to/trust-report',
    BLOG: '/blog',
    FLEEQUID_CARE_POWERTRAIN_WARRANTY: '/how-to/fleequid-care-powertrain-warranty',
    ...STORYBLOK_LEGAL_PAGES_ROUTES,
} as const;
